module.exports = __webpack_public_path__ + "static/assets/4bfd8156fc8a4ea8f495c5da5b1dbc42.png";